import { ApolloCache, DefaultContext, MutationUpdaterFunction } from '@apollo/client';
import {
  Exact,
  LocationCreateInput,
  LocationCreateMutation,
  LocationsDocument,
  LocationsQuery,
  LocationsQueryVariables,
} from 'generated/graphql';

type LocationEdge = LocationsQuery['locations']['edges'][number];

const orderEdges = (edges: LocationEdge[]) =>
  edges.sort((a, b) => a.node!.address.localeCompare(b.node!.address));

export const updateCacheOnCreate: MutationUpdaterFunction<
  LocationCreateMutation,
  Exact<{ data: LocationCreateInput }>,
  DefaultContext,
  ApolloCache<any>
> = (cache, { data: mutationData }) => {
  if (mutationData) {
    cache.updateQuery<LocationsQuery, LocationsQueryVariables>(
      { query: LocationsDocument },
      queryData => {
        if (queryData) {
          const { locationCreate: location } = mutationData;
          return {
            ...queryData,
            locations: {
              ...queryData.locations,
              edges: orderEdges([
                ...queryData.locations.edges,
                { __typename: 'LocationEdge', node: location },
              ]),
            },
          };
        }
        return null;
      }
    );
  }
};
